import { render, staticRenderFns } from "./NameServersRegisration.vue?vue&type=template&id=66013f28&"
import script from "./NameServersRegisration.vue?vue&type=script&lang=js&"
export * from "./NameServersRegisration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66013f28')) {
      api.createRecord('66013f28', component.options)
    } else {
      api.reload('66013f28', component.options)
    }
    module.hot.accept("./NameServersRegisration.vue?vue&type=template&id=66013f28&", function () {
      api.rerender('66013f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/NameServersRegisration.vue"
export default component.exports